import React from 'react';

interface LogoProps {
  size?: number; // Height of the logo (default: 32)
  showText?: boolean; // If true, shows full logo (monogram + line + text)
  color?: string; // Text color (default: 'currentColor')
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size, showText = false, color, className }) => {
  const height = size || (showText ? 36 : 32);
  const width = showText ? height * 5.2 : height;
  const viewBox = showText ? "0 0 520 100" : "0 0 100 100";
  const textColor = color || 'currentColor';

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      <defs>
        {/* bz Blue Gradient */}
        <linearGradient id="bzBlueGrad" x1="14" x2="49" y1="14" y2="86" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#1b75bc" />
          <stop offset="45%" stopColor="#0090cc" />
          <stop offset="100%" stopColor="#00a8e1" />
        </linearGradient>
        
        {/* bz Orange Gradient */}
        <linearGradient id="bzOrangeGrad" x1="64" x2="88" y1="45" y2="86" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#f7931e" />
          <stop offset="60%" stopColor="#f58220" />
          <stop offset="100%" stopColor="#f15a24" />
        </linearGradient>
      </defs>

      {/* Monogram Group */}
      <g>
        {/* Blue "b" */}
        <path
          d="M 14,14 L 14,86"
          stroke="url(#bzBlueGrad)"
          strokeWidth="14"
          strokeLinecap="round"
        />
        <circle
          cx="32"
          cy="69"
          r="17"
          stroke="url(#bzBlueGrad)"
          strokeWidth="14"
          fill="none"
        />

        {/* Orange "z" */}
        <path
          d="M 64,45 L 88,45 L 64,86 L 88,86"
          stroke="url(#bzOrangeGrad)"
          strokeWidth="14"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {/* Text Elements (only rendered if showText is true) */}
      {showText && (
        <g style={{ color: textColor }}>
          {/* Vertical Separator Line */}
          <line 
            x1="115" 
            y1="10" 
            x2="115" 
            y2="90" 
            stroke="currentColor" 
            style={{ stroke: textColor, opacity: 0.3 }}
            strokeWidth="2" 
            strokeLinecap="round"
          />

          {/* lowercase "betriebszentrale" */}
          <text 
            x="130" 
            y="60" 
            fontSize="48" 
            fontWeight="700" 
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
            letterSpacing="-1.5"
            style={{ fill: textColor }}
          >
            betriebszentrale
          </text>

          {/* uppercase subtitle */}
          <text 
            x="130" 
            y="88" 
            fontSize="12.5" 
            fontWeight="600" 
            fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" 
            letterSpacing="1.2"
            style={{ fill: textColor, opacity: 0.6 }}
          >
            DIGITALE ORGANISATION FÜR UNTERNEHMEN
          </text>
        </g>
      )}
    </svg>
  );
};
